import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, ChoiceGroup, DefaultButton, Dropdown, IChoiceGroupOption, Modal, PrimaryButton, TextField } from '@fluentui/react';
import * as Api from '../../../../api/src';
import ModalHeader from '../../../../control/modalHeader';
import { commonfn } from '../../../../common/commonfn';
import { DialogContext } from '../../../../context/dialog.context';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import { ToastAppType } from '../../../../common/constant/enum/toastAppType';
export interface ModaProductProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  Item?: any | null;
}
const UserApi = new Api.UserApi();
const ModalResetPass = ({ Item, IsOpen, onCloseModal, onSaveClick }: ModaProductProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(false);
  const [type, SetType] = React.useState<string>('');
  const [pass, SetPass] = React.useState('');
  const [passErrorMessage, SetPassErrorMessage] = React.useState('');

  const { setMsgAlertDialog } = React.useContext(DialogContext);
  const { setToastData } = React.useContext(ToastAppMsgContext);
  
  React.useEffect(() => {
    SetIsShow(IsOpen);
    SetType('Auto');
    SetPass('');
  }, [IsOpen]);

  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };

  const options: IChoiceGroupOption[] = [
    { key: 'Auto', text: 'Automatically generate a password' },
    { key: 'Manual', text: 'Create password' }
  ];

  function _onChange(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    var key = option ? option.key : '';
    SetType(key);
    if(key === 'Auto') {
      SetPass('');
    }
  }

  const onSave = async () => {
    if (!validateFormData()) return;
    try {
      console.log(Item);
      var res = await UserApi.apiUserResetPasswordPasswordGet(Item.Id || 0, pass ?? '');
      if (!res || res.status !== 200) return;
      setToastData({ Message: t('Successed'), Type: ToastAppType.Success });
      onCloseModal();
      SetIsShow(false);
      if (onSaveClick) {
        onSaveClick();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validateFormData = () => {
    if(type === 'Auto') return true;
    if (!pass) {
      SetPassErrorMessage(t('IsRequired').replace('{0}', t('Password')));
      return false;
    }
    if (pass.length < 8) {
      SetPassErrorMessage(t('Password must be at least 8 characters long'));
      return false;
    }
    return true;
  };
  
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={t('ResetPassword') + ' for ' + (Item ? Item.FullName : '')}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700 }}>
        <div className="ms-Grid" dir="ltr">

        <ChoiceGroup defaultSelectedKey="Auto" options={options} onChange={_onChange} label="" required={false} />

        {type === 'Manual' && (
          
          <div className="ms-Grid-row">
            <br></br>
          <div className="ms-md6 padding-left-20 ms-Grid-col">
            <TextField
              label={t('Password') + ' (*)'}
              errorMessage={passErrorMessage}
              value={pass}
              type="password"
              onChange={(e, newValue) => {
              const newPass = newValue || '';
              SetPass(newPass);
              if (newPass.length < 8) {
                SetPassErrorMessage(t('Password must be at least 8 characters long'));
              } else {
                SetPassErrorMessage('');
              }
              }}
            ></TextField>
          </div>
        </div>
        )}
          
          
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          onClick={() => {
            onClose();
          }}
          className={'margin-left-10'}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('Reset')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModalResetPass;
